// extracted by mini-css-extract-plugin
module.exports = {"body":"HorseItem_body__1QARQ","card":"HorseItem_card__1cfsm","bg":"HorseItem_bg__3wKyP"};